// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pf-9";
export var arrowButtonContainer = "_pf-5";
export var arrowButtonIcon = "_pf-6";
export var carouselArrowButton = "_pf-2";
export var carouselElementContainer = "_pf-1";
export var currentSlide = "_pf-8";
export var left = "_pf-3";
export var otherSlide = "_pf-a";
export var productCarouselContainer = "_pf-0";
export var right = "_pf-4";
export var sliderOverflow = "_pf-7";